export default __webpack_public_path__ + "static/media/ic_award.1d4e8fec.svg";